import { MissingMonogramValuesPerConfig, MissingOptionsPerConfiguration, MissingOptionValuesPerConfiguration } from '@susu/custom-made/utils/preloadConfiguration/preloadConfiguration';
import { createContext } from 'react';

type MissingSelectionValuesContextType = {
  showMissingFabricModal: boolean;
  setShowMissingFabricModal: (showMissingFabricModal: boolean) => void;
  showMissingOptionsPanel: boolean;
  setShowMissingOptionsPanel: (showMissingOptionsPanel: boolean) => void;
  monogramsIdsWithMissingSelection: number[];
  setMonogramsIdsWithMissingSelection: (monogramsIdsWithMissingSelection: number[]) => void;
  missingOptionValuesPerConfig: MissingOptionValuesPerConfiguration;
  setMissingOptionValuesPerConfig: (missingOptionValuesPerConfig: MissingOptionValuesPerConfiguration) => void;
  missingMonogramValuesPerConfig: MissingMonogramValuesPerConfig;
  setMissingMonogramValuesPerConfig: (missingMonogramValuesPerConfig: MissingMonogramValuesPerConfig) => void;
  missingOptionsPerConfig: MissingOptionsPerConfiguration;
  setMissingOptionsPerConfig: (missingOptionsPerConfig: MissingOptionsPerConfiguration) => void;
  isSummaryValidationTriggered: boolean;
  setIsSummaryValidationTriggered: (isSummaryValidationTriggered: boolean) => void;
};

const defaultMissingSelectionValuesContext: MissingSelectionValuesContextType = {
  showMissingFabricModal: false,
  setShowMissingFabricModal: () => {},
  showMissingOptionsPanel: false,
  setShowMissingOptionsPanel: () => {},
  monogramsIdsWithMissingSelection: [],
  setMonogramsIdsWithMissingSelection: () => {},
  missingOptionValuesPerConfig: {},
  setMissingOptionValuesPerConfig: () => {},
  missingMonogramValuesPerConfig: {},
  setMissingMonogramValuesPerConfig: () => {},
  missingOptionsPerConfig: {},
  setMissingOptionsPerConfig: () => {},
  isSummaryValidationTriggered: false,
  setIsSummaryValidationTriggered: () => {},
};

export const MissingSelectionValuesContext = createContext<MissingSelectionValuesContextType>(defaultMissingSelectionValuesContext);
